import { Dispatch } from 'redux';
import { axiosInstance, request, requestConfig } from './base';
import { UploadDocResponse } from 'store/modules/models/uploadDocResponse';
import {
  CotasDeFundoApiResponse,
  CadastroCotasDeFundoApiRequest,
  GETInstrumentosFilterParams,
  HistoricoResponse,
  SolicitarLiquidacaoRequest,
  CommandResultTyped,
  HistoricoAtualizacaoCota,
} from 'common/genericTypes';
import { errorMessages } from 'common/errorMessages.strings';
import { AditamentoDiferenca, AditamentoRevisionData } from 'components/aditamentoModal/aditamentoRevisionModal';

export const GETCotasDeFundoDetalhes = async (
  dispatch: Dispatch,
  id: string,
  stackRequest: boolean = false
): Promise<CotasDeFundoApiResponse> => {
  return await request(
    () => axiosInstance.get<CotasDeFundoApiResponse>(`${requestConfig.api}api/v1/cotas-de-fundo/${id}`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETCotasDeFundo = async (
  dispatch: Dispatch,
  params?: GETInstrumentosFilterParams,
  stackRequest: boolean = false
): Promise<Array<CotasDeFundoApiResponse>> => {
  return await request(
    () => axiosInstance.get<Array<CotasDeFundoApiResponse>>(`${requestConfig.api}api/v1/cotas-de-fundo`, params ? { params } : undefined),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETCotasDeFundoByInstrumentoId = async (
  dispatch: Dispatch,
  instrumentoId: string,
  stackRequest: boolean = false
): Promise<CotasDeFundoApiResponse> => {
  return await request(
    () => axiosInstance.get<CotasDeFundoApiResponse>(`${requestConfig.api}api/v1/cotas-de-fundo/v2/instrumento-financeiro/${instrumentoId}`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTCotasDeFundo = async (dispatch: Dispatch, cotasDeFundo: CadastroCotasDeFundoApiRequest, stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.post<CotasDeFundoApiResponse>(`${requestConfig.api}api/v1/cotas-de-fundo/v2`, cotasDeFundo),
    dispatch,
    errorMessages.instrumentoFinanceiro.generic,
    stackRequest
  );
};

export const PUTCotasDeFundo = async (
  dispatch: Dispatch,
  cotasDeFundoId: string,
  cotasDeFundo: CadastroCotasDeFundoApiRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () => axiosInstance.put<CotasDeFundoApiResponse>(`${requestConfig.api}api/v1/cotas-de-fundo/${cotasDeFundoId}`, cotasDeFundo),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PUTCotasDeFundoAditamento = async (
  dispatch: Dispatch,
  cotasDeFundoId: string,
  cotasDeFundo: CadastroCotasDeFundoApiRequest,
  date: string,
  document: File,
  stackRequest: boolean = false
) => {
  const fileForm = new FormData();
  fileForm.append('file', document);
  fileForm.append('dataAditamento', date);
  fileForm.append('aditamento', JSON.stringify(cotasDeFundo));

  return await request(
    () =>
      axiosInstance.put<string>(`${requestConfig.api}api/v1/cotas-de-fundo/aditamento/${cotasDeFundoId}`, fileForm, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
    dispatch,
    undefined,
    stackRequest
  );
};


export const PUTEditarCotasDeFundo = async (
  dispatch: Dispatch,
  cotasDeFundoId: string,
  cotasDeFundo: CadastroCotasDeFundoApiRequest,
  justificativa: string,
  document?: File,
  stackRequest: boolean = false
) => {
  const fileForm = new FormData();

  if (document) fileForm.append('file', document);
  fileForm.append('justificativa', justificativa);

  const cotasDeFundoStringfyed = JSON.stringify(cotasDeFundo);
  fileForm.append('instrumentoFinanceiroRequest', cotasDeFundoStringfyed);

  return await request(
    () =>
      axiosInstance.put<CommandResultTyped<string>>(`${requestConfig.api}api/v1/cotas-de-fundo/editar/${cotasDeFundoId}`, fileForm, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PUTUploadDoc = async (
  dispatch: Dispatch,
  cotasDeFundoId: string,
  emissionType: string,
  file: File,
  stackRequest: boolean = false
) => {
  const data = new FormData();
  data.append('file', file);
  return await request<Array<UploadDocResponse>>(
    () =>
      axiosInstance.put<Array<UploadDocResponse>>(`${requestConfig.api}api/v1/cotas-de-fundo/${cotasDeFundoId}/document`, data, {
        params: {
          emissionType,
        },
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
    dispatch,
    undefined,
    stackRequest
  );
};

export const DELETEUploadDoc = async (
  dispatch: Dispatch,
  cotasDeFundoId: string,
  cotasDeFundoDocumentId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () => axiosInstance.delete(`${requestConfig.api}api/v1/cotas-de-fundo/${cotasDeFundoId}/document/${cotasDeFundoDocumentId}`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETCotasDeFundoDocumentDownloadUrl = async (
  dispatch: Dispatch,
  cotasDeFundoId: string,
  cotasDeFundoDocumentId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () => axiosInstance.get<string>(`${requestConfig.api}api/v1/cotas-de-fundo/${cotasDeFundoId}/document/${cotasDeFundoDocumentId}/download`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTInterOpCotasDeFundo = async (dispatch: Dispatch, cotasDeFundo: CadastroCotasDeFundoApiRequest, stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.post<CotasDeFundoApiResponse>(`${requestConfig.api}api/v1/cotas-de-fundo/transferencia-dvm`, cotasDeFundo),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTEnviarLiquidacao = async (
  dispatch: Dispatch,
  cotasDeFundoId: string,
  cotasDeFundoSolicitarLiquidacaoRequest: SolicitarLiquidacaoRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post<CotasDeFundoApiResponse>(
        `${requestConfig.api}api/v1/cotas-de-fundo/${cotasDeFundoId}/enviar-liquidacao`,
        cotasDeFundoSolicitarLiquidacaoRequest
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTConfirmarLiquidacaoCotasDeFundo = async (dispatch: Dispatch, cotasDeFundoId: string, precoUnitarioLiquidacao: number, stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.post<CotasDeFundoApiResponse>(`${requestConfig.api}api/v1/cotas-de-fundo/${cotasDeFundoId}/confirmar-liquidacao`,
      { precoUnitario: precoUnitarioLiquidacao },
      { headers: { 'Content-Type': 'application/json' } }),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETHistoricoCotasDeFundo = async (dispatch: Dispatch, cotasDeFundoId: string, stackRequest: boolean = false) => {
  return await request(
    () =>
      axiosInstance.get<Array<HistoricoResponse>>(`${requestConfig.api}api/v1/cotas-de-fundo/${cotasDeFundoId}/historico-de-alteracoes`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETAditamentoCotasDeFundo = async (dispatch: Dispatch, aditamentoId: string, stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.get<AditamentoRevisionData>(`${requestConfig.api}api/v1/cotas-de-fundo/aditamento/${aditamentoId}`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PUTAditamentoCotasDeFundo = async (dispatch: Dispatch, aditamentoId: string, diferenca: AditamentoDiferenca[], stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.put<Array<AditamentoDiferenca>>(`${requestConfig.api}api/v1/cotas-de-fundo/aditamento/atualizar/${aditamentoId}`, diferenca),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETAtualizacoesCotasDeFundo = async (
  dispatch: Dispatch,
  cotasDeFundoId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.get<Array<HistoricoAtualizacaoCota>>(
        `${requestConfig.api}api/v1/cotas-de-fundo/${cotasDeFundoId}/atualizacao-cotas`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTAtualizacaoCotasDeFundo = async (
  dispatch: Dispatch,
  cotasDeFundoId: string,
  dataReferencia: string,
  valorCota: number,
  patrimonioLiquido: number,
  rentabilidadeDia: number,
  rentabilidadeMes: number,
  rentabilidadeAno: number,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post<HistoricoAtualizacaoCota>(
        `${requestConfig.api}api/v1/cotas-de-fundo/${cotasDeFundoId}/atualizacao-cotas`,
        {
          dataReferencia,
          valorCota,
          patrimonioLiquido,
          rentabilidadeDia,
          rentabilidadeMes,
          rentabilidadeAno,
        },
        { headers: { 'Content-Type': 'application/json' } }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PUTAtualizacaoCotasDeFundo = async (
  dispatch: Dispatch,
  cotasDeFundoId: string,
  valorCotaId: string,
  dataReferencia: string,
  valorCota: number,
  patrimonioLiquido: number,
  rentabilidadeDia: number,
  rentabilidadeMes: number,
  rentabilidadeAno: number,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.put<HistoricoAtualizacaoCota>(
        `${requestConfig.api}api/v1/cotas-de-fundo/${cotasDeFundoId}/atualizacao-cotas/${valorCotaId}`,
        {
          dataReferencia,
          valorCota,
          patrimonioLiquido,
          rentabilidadeDia,
          rentabilidadeMes,
          rentabilidadeAno,
        },
        { headers: { 'Content-Type': 'application/json' } }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const DELETEAtualizacaoCotasDeFundo = async (
  dispatch: Dispatch,
  cotasDeFundoId: string,
  valorCotaId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.delete(
        `${requestConfig.api}api/v1/cotas-de-fundo/${cotasDeFundoId}/atualizacao-cotas/${valorCotaId}`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};
